export default __webpack_public_path__ + "static/media/experiencePdf.b7f0b306.jpg";